import { useState } from "react";
import { toast } from "sonner";
import { Loader2, UploadCloud, Play } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { identifyFile, identifyUrl, SAMPLES, errMsg } from "../lib/api";
import { Stream } from "./Cell";

export const BatchEval = ({ onDone, setKernel }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const [log, setLog] = useState([]);

  const add = (files) => setItems((p) => [...p, ...[...files].map((f) => ({ file: f, label: f.name.replace(/\.[^.]+$/, "").replace(/[_-]+/g, " ") }))]);

  const run = async (list) => {
    setBusy(true); setLog([]); setKernel?.("busy");
    for (let i = 0; i < list.length; i++) {
      const it = list[i];
      try {
        const r = await (it.file ? identifyFile(it.file, it.label) : identifyUrl(it.url, it.label));
        setLog((l) => [...l, `[${i + 1}/${list.length}] y="${it.label}"  ŷ="${r.predictions[0].scientific_name}"  p=${r.predictions[0].probability.toFixed(3)}  ${r.uncertain ? "ABSTAIN" : "ACCEPT"}`]);
      } catch (e) { setLog((l) => [...l, `[${i + 1}/${list.length}] ERROR ${it.label}: ${errMsg(e)}`]); }
      onDone();
    }
    setBusy(false); setItems([]); setKernel?.("idle"); toast.success("Evaluation run complete");
  };

  return (
    <div className="space-y-3" data-testid="eval-batch-panel">
      <div className="flex flex-wrap gap-2">
        <Button data-testid="eval-run-samples-button" size="sm" variant="outline" disabled={busy} onClick={() => run(SAMPLES)}><Play className="h-3.5 w-3.5 mr-1.5" />Run iNaturalist reference benchmark ({SAMPLES.length})</Button>
        <label data-testid="eval-test-upload-zone" className="inline-flex items-center gap-2 rounded border border-dashed px-3 h-9 text-sm cursor-pointer hover:border-primary transition-colors">
          <UploadCloud className="h-4 w-4 text-primary" />Add labelled images
          <input data-testid="eval-test-upload-input" type="file" multiple accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => add(e.target.files)} />
        </label>
      </div>
      {items.length > 0 && (
        <div className="space-y-2 max-w-2xl">
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-3">
              <span className="text-xs font-mono text-muted-foreground w-40 truncate">{it.file.name}</span>
              <Input data-testid={`eval-label-input-${i}`} className="font-mono text-sm h-8" value={it.label} onChange={(e) => setItems((p) => p.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))} placeholder="Genus species" />
            </div>
          ))}
          <Button data-testid="eval-run-button" size="sm" disabled={busy || items.some((x) => !x.label.trim())} onClick={() => run(items)}>Run evaluation ({items.length})</Button>
        </div>
      )}
      {(busy || log.length > 0) && (
        <Stream testid="eval-progress">{log.join("\n")}{busy && <span className="inline-flex items-center gap-1 text-muted-foreground">{log.length ? "\n" : ""}<Loader2 className="h-3 w-3 animate-spin" /> running (~20 s / image)…</span>}</Stream>
      )}
    </div>
  );
};
